import AircraftPartCategoryPage from "@/components/AircraftPartCategoryPage";

const AircraftPartList = () => (
  <AircraftPartCategoryPage/>
);

export default AircraftPartList;